export function agreementtoReviveContract2026() {
return [   // Release 2025-12-19 09:08:38
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 218.185,
   left: 445.898,
   width: 128.371,
   height: 12.083
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 240.589,
   left: 225.12,
   width: 163.32,
   height: 12.731
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 253.965,
   left: 44.5093,
   width: 493.6377,
   height: 11.527
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 266.575,
   left: 70.68,
   width: 467.618,
   height: 13.385
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 281.8,
   left: 429.24,
   width: 144.84,
   height: 12.731
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 310.91,
   left: 43.2002,
   width: 546.6558,
   height: 137.856
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.675,
   left: 91.6368,
   width: 436.6922,
   height: 12.181
}
,
{
   page: 0,
   name: "Date Terminated", 
   fontSize: 9,
   type: "date",
   top: 483.48,
   left: 331.2,
   width: 150.72,
   height: 14.04
}
,
{
   page: 0,
   name: "Time of Day Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 708.96,
   left: 383.4,
   width: 120.12,
   height: 17.76
}
,
{
   page: 0,
   name: "Checkbox NoChange Time of Day Deadline", 
   isText: false,
   type: "checkbox",
   top: 712.8032,
   left: 519.057,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 0,
   name: "Checkbox Delete Time of Day Deadline", 
   isText: false,
   type: "checkbox",
   top: 713.4577,
   left: 554.402,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 0,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 728.28,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 0,
   name: "Alternative Earnest Money Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 728.28,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 0,
   name: "Checkbox NoChange Alternative Earnest Money Deadline", 
   isText: false,
   type: "checkbox",
   top: 736.3669,
   left: 519.057,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 0,
   name: "Checkbox Delete Alternative Earnest Money Deadline", 
   isText: false,
   type: "checkbox",
   top: 736.3669,
   left: 554.402,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 1,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 77.64,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Record Title Deadline and Tax Certificate", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 77.64,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Record Title Deadline and Tax Certificate", 
   isText: false,
   type: "checkbox",
   top: 85.746,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Record Title Deadline and Tax Certificate", 
   isText: false,
   type: "checkbox",
   top: 85.091,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 105.72,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Record Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 105.72,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Record Title Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 114.546,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Record Title Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 113.891,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 133.8,
   left: 316.32,
   width: 65.16,
   height: 26.76
}
,
{
   page: 1,
   name: "OffRecord Title Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 133.8,
   left: 383.76,
   width: 119.40,
   height: 26.76
}
,
{
   page: 1,
   name: "Checkbox NoChange OffRecord Title Deadline", 
   isText: false,
   type: "checkbox",
   top: 142.037,
   left: 519.057,
   width: 10.735,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete OffRecord Title Deadline", 
   isText: false,
   type: "checkbox",
   top: 141.382,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 162.12,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "OffRecord Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 162.12,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange OffRecord Title Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 169.528,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete OffRecord Title Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 170.183,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 190.2,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Title Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 190.2,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Title Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 198.328,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Title Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 197.674,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 218.28,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.28,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Third Party Right to PurchaseApprove Deadline", 
   isText: false,
   type: "checkbox",
   top: 225.819,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Third Party Right to PurchaseApprove Deadline", 
   isText: false,
   type: "checkbox",
   top: 225.819,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 258.84,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Association Documents Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 258.84,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Association Documents Deadline", 
   isText: false,
   type: "checkbox",
   top: 266.401,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Association Documents Deadline", 
   isText: false,
   type: "checkbox",
   top: 267.056,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 286.92,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Association Documents Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 286.92,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Association Documents Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 294.547,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Association Documents Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 295.201,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 327.48,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Sellers Property Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327.48,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Sellers Property Disclosure Deadline", 
   isText: false,
   type: "checkbox",
   top: 335.783,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Sellers Property Disclosure Deadline", 
   isText: false,
   type: "checkbox",
   top: 335.129,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 355.56,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.56,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange LeadBased Paint Disclosure Deadline", 
   isText: false,
   type: "checkbox",
   top: 363.274,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete LeadBased Paint Disclosure Deadline", 
   isText: false,
   type: "checkbox",
   top: 363.274,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 396.12,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "New Loan Application Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 396.12,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange New Loan Application Deadline", 
   isText: false,
   type: "checkbox",
   top: 403.856,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete New Loan Application Deadline", 
   isText: false,
   type: "checkbox",
   top: 403.856,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 424.2,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "New Loan Terms Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 424.2,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange New Loan Terms Deadline", 
   isText: false,
   type: "checkbox",
   top: 432.656,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete New Loan Terms Deadline", 
   isText: false,
   type: "checkbox",
   top: 432.002,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 452.28,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "New Loan Availability Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 452.28,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange New Loan Availability Deadline", 
   isText: false,
   type: "checkbox",
   top: 459.493,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete New Loan Availability Deadline", 
   isText: false,
   type: "checkbox",
   top: 458.838,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 480.36,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 480.36,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Buyers Credit Information Deadline", 
   isText: false,
   type: "checkbox",
   top: 488.948,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Buyers Credit Information Deadline", 
   isText: false,
   type: "checkbox",
   top: 488.293,
   left: 555.712,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 508.44,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 508.44,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Disapproval of Buyers Credit Information Deadline", 
   isText: false,
   type: "checkbox",
   top: 516.439,
   left: 519.711,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Disapproval of Buyers Credit Information Deadline", 
   isText: false,
   type: "checkbox",
   top: 515.784,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 536.52,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Existing Loan Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 536.52,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Existing Loan Deadline", 
   isText: false,
   type: "checkbox",
   top: 544.584,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Existing Loan Deadline", 
   isText: false,
   type: "checkbox",
   top: 544.584,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 564.6,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Existing Loan Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 564.6,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Existing Loan Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 572.075,
   left: 519.711,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Existing Loan Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 572.075,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 592.68,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Loan Transfer Approval Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 592.68,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 600.875,
   left: 518.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 600.875,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 620.76,
   left: 316.32,
   width: 65.16,
   height: 26.76
}
,
{
   page: 1,
   name: "Seller or Private Financing Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 620.76,
   left: 383.76,
   width: 119.40,
   height: 26.76
}
,
{
   page: 1,
   name: "Checkbox NoChange Seller or Private Financing Deadline", 
   isText: false,
   type: "checkbox",
   top: 629.021,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Seller or Private Financing Deadline", 
   isText: false,
   type: "checkbox",
   top: 629.021,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 661.32,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Appraisal Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 661.32,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Appraisal Deadline", 
   isText: false,
   type: "checkbox",
   top: 668.948,
   left: 518.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Delete Appraisal Deadline", 
   isText: false,
   type: "checkbox",
   top: 669.603,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 689.4,
   left: 316.32,
   width: 65.16,
   height: 26.76
}
,
{
   page: 1,
   name: "Appraisal Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 689.4,
   left: 383.76,
   width: 119.40,
   height: 26.76
}
,
{
   page: 1,
   name: "Checkbox NoChange Appraisal Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 697.7485,
   left: 518.402,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 1,
   name: "Checkbox Delete Appraisal Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 697.7485,
   left: 555.712,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 1,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 717.72,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 1,
   name: "Appraisal Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.72,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 1,
   name: "Checkbox NoChange Appraisal Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 725.2396,
   left: 519.057,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 1,
   name: "Checkbox Delete Appraisal Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 725.2396,
   left: 555.057,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 2,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 77.64,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "New ILC or New Survey Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 77.64,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange New ILC or New Survey Deadline", 
   isText: false,
   type: "checkbox",
   top: 85.746,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete New ILC or New Survey Deadline", 
   isText: false,
   type: "checkbox",
   top: 85.746,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 105.72,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "New ILC or New Survey Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 105.72,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange New ILC or New Survey Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 113.891,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete New ILC or New Survey Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 113.237,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 133.8,
   left: 316.32,
   width: 65.16,
   height: 26.76
}
,
{
   page: 2,
   name: "New ILC or New Survey Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 133.8,
   left: 383.76,
   width: 119.40,
   height: 26.76
}
,
{
   page: 2,
   name: "Checkbox NoChange New ILC or New Survey Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 142.037,
   left: 518.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete New ILC or New Survey Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 142.037,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 174.36,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Water Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 174.36,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Water Rights Examination Deadline", 
   isText: false,
   type: "checkbox",
   top: 182.619,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Water Rights Examination Deadline", 
   isText: false,
   type: "checkbox",
   top: 181.964,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 202.44,
   left: 316.32,
   width: 65.16,
   height: 26.76
}
,
{
   page: 2,
   name: "Mineral Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 202.44,
   left: 383.76,
   width: 119.40,
   height: 26.76
}
,
{
   page: 2,
   name: "Checkbox NoChange Mineral Rights Examination Deadline", 
   isText: false,
   type: "checkbox",
   top: 210.765,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Mineral Rights Examination Deadline", 
   isText: false,
   type: "checkbox",
   top: 210.11,
   left: 555.057,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 230.76,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 230.76,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Inspection Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 238.256,
   left: 518.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Inspection Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 238.256,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 258.84,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Inspection Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 258.84,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Inspection Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 265.747,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Inspection Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 266.401,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 286.92,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Inspection Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 286.92,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Inspection Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 294.547,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Inspection Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 294.201,
   left: 554.712,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 315,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Property Insurance Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 315,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Property Insurance Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 322.692,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Property Insurance Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 322.692,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 343.08,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 343.08,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Due Diligence Documents Delivery Deadline", 
   isText: false,
   type: "checkbox",
   top: 350.838,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Due Diligence Documents Delivery Deadline", 
   isText: false,
   type: "checkbox",
   top: 350.183,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 371.16,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Due Diligence Documents Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 371.16,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Due Diligence Documents Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 378.983,
   left: 519.057,
   width: 10.080,
   height: 10.081
}
,
{
   page: 2,
   name: "Checkbox Delete Due Diligence Documents Objection Deadline", 
   isText: false,
   type: "checkbox",
   top: 378.983,
   left: 555.057,
   width: 10.080,
   height: 10.081
}
,
{
   page: 2,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 399.24,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 399.24,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Due Diligence Documents Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 406.475,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Due Diligence Documents Resolution Deadline", 
   isText: false,
   type: "checkbox",
   top: 406.475,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateEnvironmental Inspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 427.32,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Environmental Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 427.32,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Environmental Inspection Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 434.62,
   left: 519.711,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Delete Environmental Inspection Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 434.62,
   left: 555.057,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "DateADA Evaluation Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 455.4,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "ADA Evaluation Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.4,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange ADA Evaluation Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 463.42,
   left: 519.057,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Delete ADA Evaluation Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 462.766,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 483.48,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Conditional Sale Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 483.48,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Conditional Sale Deadline", 
   isText: false,
   type: "checkbox",
   top: 490.911,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Conditional Sale Deadline", 
   isText: false,
   type: "checkbox",
   top: 490.911,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 511.56,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "LeadBased Paint Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 511.56,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange LeadBased Paint Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 519.057,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete LeadBased Paint Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 519.366,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateEstoppel Statements Deadline", 
   fontSize: 9,
   type: "date",
   top: 539.64,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Estoppel Statements Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 539.64,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Estoppel Statements Deadline", 
   isText: false,
   type: "checkbox",
   top: 547.202,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Estoppel Statements Deadline", 
   isText: false,
   type: "checkbox",
   top: 547.202,
   left: 555.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateEstoppel Statements Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 567.72,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Estoppel Statements Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567.72,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Estoppel Statements Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 575.348,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Estoppel Statements Termination Deadline", 
   isText: false,
   type: "checkbox",
   top: 575.348,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 608.28,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Closing Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 608.28,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Closing Date", 
   isText: false,
   type: "checkbox",
   top: 615.93,
   left: 519.057,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Delete Closing Date", 
   isText: false,
   type: "checkbox",
   top: 616.585,
   left: 555.712,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 636.36,
   left: 316.32,
   width: 65.16,
   height: 26.76
}
,
{
   page: 2,
   name: "Possession Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 636.36,
   left: 383.76,
   width: 119.40,
   height: 26.76
}
,
{
   page: 2,
   name: "Checkbox NoChange Possession Date", 
   isText: false,
   type: "checkbox",
   top: 644.73,
   left: 519.057,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Delete Possession Date", 
   isText: false,
   type: "checkbox",
   top: 644.73,
   left: 554.402,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Possession Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.68,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Checkbox NoChange Possession Time", 
   isText: false,
   type: "checkbox",
   top: 672.221,
   left: 519.057,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Checkbox Delete Possession Time", 
   isText: false,
   type: "checkbox",
   top: 672.221,
   left: 554.402,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Extra Row 46", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.6476,
   left: 50.4,
   width: 21.24,
   height: 25.1456
}
,
{
   page: 2,
   name: "Extra Row 46 Section Number", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 691.92,
   left: 72.0546,
   width: 27.0654,
   height: 27.36
}
,
{
   page: 2,
   name: "Extra Row 46 Deadline Name", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.76,
   left: 100.32,
   width: 213.72,
   height: 26.52
}
,
{
   page: 2,
   name: "Date Extra Row 46", 
   fontSize: 9,
   type: "date",
   top: 692.76,
   left: 316.32,
   width: 65.16,
   height: 26.52
}
,
{
   page: 2,
   name: "Extra Row 46 Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 692.76,
   left: 383.76,
   width: 119.40,
   height: 26.52
}
,
{
   page: 2,
   name: "Extra Row 47", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 720.0,
   left: 49.8,
   width: 21.829,
   height: 16.6909
}
,
{
   page: 2,
   name: "Extra Row 47 Section Number", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 719.0296,
   left: 73.6145,
   width: 24.9055,
   height: 18.6001
}
,
{
   page: 2,
   name: "Extra Row 47 Deadline Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 720.48,
   left: 99.96,
   width: 214.44,
   height: 17.52
}
,
{
   page: 2,
   name: "Date Extra Row 47", 
   fontSize: 9,
   type: "date",
   top: 720.48,
   left: 315.96,
   width: 65.88,
   height: 17.52
}
,
{
   page: 2,
   name: "or DeadlineRow26", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 720.48,
   left: 383.4,
   width: 120.12,
   height: 17.52
}
,
{
   page: 2,
   name: "Checkbox Extra Row 46 No Change", 
   isText: false,
   type: "checkbox",
   top: 700.3668,
   left: 519.057,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 2,
   name: "Checkbox Extra Row 46 Delete", 
   isText: false,
   type: "checkbox",
   top: 700.3668,
   left: 555.057,
   width: 10.080,
   height: 10.0800
}
,
{
   page: 2,
   name: "Checkbox Extra Row 47 No Change", 
   isText: false,
   type: "checkbox",
   top: 723.2759,
   left: 519.711,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 2,
   name: "Checkbox Extra Row 47 Delete", 
   isText: false,
   type: "checkbox",
   top: 723.2759,
   left: 555.057,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 3,
   name: "Other Date or Deadline Changes", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 50.4,
   left: 42.5456,
   width: 540.7654,
   height: 80.255
}
,
{
   page: 3,
   name: "Additional Amendments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 141.692,
   left: 43.2002,
   width: 541.4198,
   height: 236.037
}
,
{
   page: 3,
   name: "Date Revive Contract Acceptance Deadline", 
   fontSize: 9,
   type: "date",
   top: 445.2,
   left: 295.56,
   width: 105.00,
   height: 10.68
}
,
{
   page: 3,
   name: "Time Revive Contract Acceptance", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 445.2,
   left: 408.0,
   width: 105.0,
   height: 10.68
}
] }
